// API utility functions for backend communication
const API_URL = process.env.REACT_APP_API_URL || "http://localhost:3001";

class ApiError extends Error {
  constructor(message, status, data) {
    super(message);
    this.status = status;
    this.data = data;
    this.name = "ApiError";
  }
}

const getAuthToken = () => {
  return localStorage.getItem("authToken");
};

const setAuthToken = (token) => {
  if (token) {
    localStorage.setItem("authToken", token);
  } else {
    localStorage.removeItem("authToken");
  }
};

// Registered by AuthProvider so the API layer can trigger logout on 401.
let onUnauthorizedCallback = null;
const onUnauthorized = (cb) => {
  onUnauthorizedCallback = cb;
};

const apiRequest = async (endpoint, options = {}) => {
  const { requiresAuth = false, ...fetchOptions } = options;

  // Don't set Content-Type for FormData — the browser must set it with the
  // multipart boundary, otherwise the server can't parse the body.
  const isFormData = fetchOptions.body instanceof FormData;
  const headers = {
    ...(isFormData ? {} : { "Content-Type": "application/json" }),
    ...fetchOptions.headers,
  };

  if (requiresAuth) {
    const token = getAuthToken();
    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
  }

  const config = {
    ...fetchOptions,
    headers,
  };

  const url = `${API_URL}${endpoint}`;

  try {
    const response = await fetch(url, config);
    const data = await response.json();

    if (!response.ok) {
      if (response.status === 401 && onUnauthorizedCallback) {
        onUnauthorizedCallback();
      }
      throw new ApiError(
        data.message || "Request failed",
        response.status,
        data,
      );
    }

    return data;
  } catch (error) {
    if (error instanceof ApiError) {
      throw error;
    }
    throw new ApiError("Network error", 0, { originalError: error.message });
  }
};

export {
  API_URL,
  ApiError,
  getAuthToken,
  setAuthToken,
  apiRequest,
  onUnauthorized,
};
